var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaDipendente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fz7ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 21.89h23.624v8.765H8z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fz7ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.55h23.623v12.706H8z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#67a2ad",
    d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M16.42 24.104c.383 0 .697-.327.697-.726V21.976c0-.4-.314-.726-.698-.726h-.861c-.384 0-.698.327-.698.726V23.378c0 .4.314.726.698.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M24.054 24.104c.38 0 .69-.327.69-.726V21.976c0-.4-.31-.726-.69-.726H23.2c-.38 0-.69.327-.69.726V23.378c0 .4.31.726.69.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fz7ab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M29.108 22.98H25.18v.888a.797.797 0 0 1-.795.795h-1.5a.797.797 0 0 1-.795-.795v-.888h-4.557v.888a.797.797 0 0 1-.794.795h-1.5a.797.797 0 0 1-.795-.795v-.888h-3.928A3.413 3.413 0 0 1 8 21.89v5.76a3.014 3.014 0 0 0 3.005 3.005H28.62a3.014 3.014 0 0 0 3.005-3.006V21.89a3.41 3.41 0 0 1-2.516 1.09"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fz7ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M17.515 14.528V12.43c0-.207.168-.375.375-.375h3.844c.276 0 .374.402.374.746v1.726zm7.1 0v-1.726c0-1.23-.484-1.986-.89-2.404a2.795 2.795 0 0 0-1.991-.848H17.89a2.884 2.884 0 0 0-2.882 2.881v2.097h-4.003A3.014 3.014 0 0 0 8 17.533v3.428a3.042 3.042 0 0 0 2.515 1.295h3.929v-.93c0-.437.357-.794.795-.794h1.5c.437 0 .794.357.794.794v.93h4.557v-.93c0-.437.357-.794.794-.794h1.5c.437 0 .795.357.795.794v.93h3.928c1.054 0 1.981-.517 2.517-1.295v-3.428a3.015 3.015 0 0 0-3.006-3.005z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaDipendente);
export default __webpack_public_path__ + "static/media/IconaDipendente.d0831c838ce9cff4f77a7e90852c817d.svg";
export { ForwardRef as ReactComponent };